import { RouteProps } from '../../routes/AppRouter'
import { PatientFormView as View } from '../../features/form-patients'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

type PatientFormProps = {
  edit?: boolean
} & RouteProps

export function PatientFormView(props: PatientFormProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)
  const state: PatientFormProps = props.location?.state as PatientFormProps

  return <View id={props.id || ''} edit={!!state.edit} />
}
